import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { appInsightsConfig } from '@/config/appinsights';

const appInsights = new ApplicationInsights({
    config: appInsightsConfig
});

appInsights.loadAppInsights();
appInsights.trackPageView();
